// extracted by mini-css-extract-plugin
export var controls = "Pagination-module--controls--6c92f";
export var largepaginationcontrol = "Pagination-module--largepaginationcontrol--939a4";
export var narrow = "Pagination-module--narrow--755d3";
export var nobackground = "Pagination-module--nobackground--15a12";
export var nooffset = "Pagination-module--nooffset--7da05";
export var paginationtext = "Pagination-module--paginationtext--82ba1";
export var paginationwrapper = "Pagination-module--paginationwrapper--b84d7";
export var slim = "Pagination-module--slim--a3ee5";
export var smallpaginationcontrol = "Pagination-module--smallpaginationcontrol--46f12 Pagination-module--largepaginationcontrol--939a4";
export var withshowall = "Pagination-module--withshowall--8bb18";